module.exports = __webpack_public_path__ + "static/img/banner.3e32802.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/tqjg/banner.jpg
// module id = o+Wc
// module chunks = 23